"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
const palette_1 = __importDefault(require("./palette"));
const themeColor = palette_1.default.light;
const LIGHT_MODE = themeColor.common.black;
const DARK_MODE = themeColor.common.black;
function createShadow(themeMode, color) {
    const transparent = (0, styles_1.alpha)(color, 0.16);
    return {
        z1: `0 1px 2px 0 ${transparent}`,
        z4: `0 4px 8px 0 ${transparent}`,
        z8: `0 8px 16px 0 ${transparent}`,
        z12: `0 12px 24px -4px ${transparent}`,
        z16: `0 16px 32px -4px ${transparent}`,
        z20: `0 20px 40px -4px ${transparent}`,
        z24: `0 24px 48px 0 ${transparent}`,
        //
        primary: `0 8px 16px 0 ${(0, styles_1.alpha)(palette_1.default[themeMode].primary.main, 0.24)}`,
        info: `0 8px 16px 0 ${(0, styles_1.alpha)(palette_1.default[themeMode].info.main, 0.24)}`,
        secondary: `0 8px 16px 0 ${(0, styles_1.alpha)(palette_1.default[themeMode].secondary.main, 0.24)}`,
        success: `0 8px 16px 0 ${(0, styles_1.alpha)(palette_1.default[themeMode].success.main, 0.24)}`,
        warning: `0 8px 16px 0 ${(0, styles_1.alpha)(palette_1.default[themeMode].warning.main, 0.24)}`,
        error: `0 8px 16px 0 ${(0, styles_1.alpha)(palette_1.default[themeMode].error.main, 0.24)}`,
        //
        card: `0 0 2px 0 ${(0, styles_1.alpha)(color, 0.2)}, 0 12px 24px -4px ${(0, styles_1.alpha)(color, 0.12)}`,
        dialog: `-40px 40px 80px -8px ${(0, styles_1.alpha)(color, 0.24)}`,
        dropdown: `0 0 2px 0 ${(0, styles_1.alpha)(color, 0.24)}, -20px 20px 40px -4px ${(0, styles_1.alpha)(color, 0.24)}`,
    };
}
function customShadows(themeMode) {
    return themeMode === 'light' ? createShadow(themeMode, LIGHT_MODE) : createShadow(themeMode, DARK_MODE);
}
exports.default = customShadows;
